/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProviderCredentialFormConfiguration
 */
export interface ProviderCredentialFormConfiguration {
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof ProviderCredentialFormConfiguration
     */
    readonly channels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showTargetBranch?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showAgencyId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showAgentName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showAgentPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showPCC?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showSubscriptionKey?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showTarget?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showB2BAPIUserPassword?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showB2BAPIUserEmailAddress?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showServiceUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showClientId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showClientSecret?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showAuthenticationUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showAccessGroup?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showShoppingUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showShoppingClientSecret?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showShoppingClientId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showShoppingServiceUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showPostShoppingUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showPostShoppingClientSecret?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showPostShoppingClientId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProviderCredentialFormConfiguration
     */
    showPostShoppingServiceUrl?: boolean;
    /**
     * 
     * @type {Array<BrandAndMarketListItem>}
     * @memberof ProviderCredentialFormConfiguration
     */
    readonly brandsAndMarkets?: Array<BrandAndMarketListItem> | null;
}

export function ProviderCredentialFormConfigurationFromJSON(json: any): ProviderCredentialFormConfiguration {
    return ProviderCredentialFormConfigurationFromJSONTyped(json, false);
}

export function ProviderCredentialFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderCredentialFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'channels': !exists(json, 'channels') ? undefined : (json['channels'] === null ? null : (json['channels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'showTargetBranch': !exists(json, 'showTargetBranch') ? undefined : json['showTargetBranch'],
        'showAgencyId': !exists(json, 'showAgencyId') ? undefined : json['showAgencyId'],
        'showAgentName': !exists(json, 'showAgentName') ? undefined : json['showAgentName'],
        'showAgentPassword': !exists(json, 'showAgentPassword') ? undefined : json['showAgentPassword'],
        'showPCC': !exists(json, 'showPCC') ? undefined : json['showPCC'],
        'showSubscriptionKey': !exists(json, 'showSubscriptionKey') ? undefined : json['showSubscriptionKey'],
        'showTarget': !exists(json, 'showTarget') ? undefined : json['showTarget'],
        'showB2BAPIUserPassword': !exists(json, 'showB2BAPIUserPassword') ? undefined : json['showB2BAPIUserPassword'],
        'showB2BAPIUserEmailAddress': !exists(json, 'showB2BAPIUserEmailAddress') ? undefined : json['showB2BAPIUserEmailAddress'],
        'showServiceUrl': !exists(json, 'showServiceUrl') ? undefined : json['showServiceUrl'],
        'showClientId': !exists(json, 'showClientId') ? undefined : json['showClientId'],
        'showClientSecret': !exists(json, 'showClientSecret') ? undefined : json['showClientSecret'],
        'showAuthenticationUrl': !exists(json, 'showAuthenticationUrl') ? undefined : json['showAuthenticationUrl'],
        'showAccessGroup': !exists(json, 'showAccessGroup') ? undefined : json['showAccessGroup'],
        'showShoppingUrl': !exists(json, 'showShoppingUrl') ? undefined : json['showShoppingUrl'],
        'showShoppingClientSecret': !exists(json, 'showShoppingClientSecret') ? undefined : json['showShoppingClientSecret'],
        'showShoppingClientId': !exists(json, 'showShoppingClientId') ? undefined : json['showShoppingClientId'],
        'showShoppingServiceUrl': !exists(json, 'showShoppingServiceUrl') ? undefined : json['showShoppingServiceUrl'],
        'showPostShoppingUrl': !exists(json, 'showPostShoppingUrl') ? undefined : json['showPostShoppingUrl'],
        'showPostShoppingClientSecret': !exists(json, 'showPostShoppingClientSecret') ? undefined : json['showPostShoppingClientSecret'],
        'showPostShoppingClientId': !exists(json, 'showPostShoppingClientId') ? undefined : json['showPostShoppingClientId'],
        'showPostShoppingServiceUrl': !exists(json, 'showPostShoppingServiceUrl') ? undefined : json['showPostShoppingServiceUrl'],
        'brandsAndMarkets': !exists(json, 'brandsAndMarkets') ? undefined : (json['brandsAndMarkets'] === null ? null : (json['brandsAndMarkets'] as Array<any>).map(BrandAndMarketListItemFromJSON)),
    };
}

export function ProviderCredentialFormConfigurationToJSON(value?: ProviderCredentialFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showTargetBranch': value.showTargetBranch,
        'showAgencyId': value.showAgencyId,
        'showAgentName': value.showAgentName,
        'showAgentPassword': value.showAgentPassword,
        'showPCC': value.showPCC,
        'showSubscriptionKey': value.showSubscriptionKey,
        'showTarget': value.showTarget,
        'showB2BAPIUserPassword': value.showB2BAPIUserPassword,
        'showB2BAPIUserEmailAddress': value.showB2BAPIUserEmailAddress,
        'showServiceUrl': value.showServiceUrl,
        'showClientId': value.showClientId,
        'showClientSecret': value.showClientSecret,
        'showAuthenticationUrl': value.showAuthenticationUrl,
        'showAccessGroup': value.showAccessGroup,
        'showShoppingUrl': value.showShoppingUrl,
        'showShoppingClientSecret': value.showShoppingClientSecret,
        'showShoppingClientId': value.showShoppingClientId,
        'showShoppingServiceUrl': value.showShoppingServiceUrl,
        'showPostShoppingUrl': value.showPostShoppingUrl,
        'showPostShoppingClientSecret': value.showPostShoppingClientSecret,
        'showPostShoppingClientId': value.showPostShoppingClientId,
        'showPostShoppingServiceUrl': value.showPostShoppingServiceUrl,
    };
}


